import React from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";

/**
 * La tuerca para administrar un registro, con el mismo aspecto de los botones
 * de general/BotonesAccion (que no trae uno de tuerca). Esta aqui para no
 * tocar ese archivo, que usan todos los modulos.
 */
const BtnAdministrar = ({ callback, texto, color }) => (
  <Tooltip title={texto}>
    <IconButton style={{ color }} aria-label={texto} onClick={callback}>
      <SettingsIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

BtnAdministrar.propTypes = {
  callback: PropTypes.func.isRequired,
  texto: PropTypes.string,
  color: PropTypes.string,
};

BtnAdministrar.defaultProps = { texto: "Administrar", color: "#424242" };

export default BtnAdministrar;
